'use strict'

/**
 * Browser-side upload constraints for master-lot settlement documents.
 *
 * Answers: "what's allowed and how big?"
 *
 * Single source of truth: the dialog uses these for the file-input
 * `accept` attribute + client-side validation; the mock api re-validates
 * on presign so the v1 swap to a real BE keeps the same enforcement
 * points. Mirrors the shape PR #1183 established for assay photos
 * (`assayPhotoUploadConstraints.js`), extended to PDFs since settlement
 * statements arrive as PDF more often than not.
 */

export const MASTER_LOT_SETTLEMENT_DOC_ALLOWED_MIME_TYPES = Object.freeze([
  'application/pdf',
  'image/jpeg',
  'image/png',
])

export const MASTER_LOT_SETTLEMENT_DOC_ACCEPT_ATTRIBUTE =
  MASTER_LOT_SETTLEMENT_DOC_ALLOWED_MIME_TYPES.join(',')

// TODO(UCG-2210): client-side image resize before upload once Connor's shared
// lambda resizer lands — reuse the same seam for settlement-doc JPEG/PNG.
export const MASTER_LOT_SETTLEMENT_DOC_MAX_UPLOAD_BYTES = 5 * 1024 * 1024

export const MASTER_LOT_SETTLEMENT_DOC_MAX_UPLOAD_MB =
  MASTER_LOT_SETTLEMENT_DOC_MAX_UPLOAD_BYTES / 1024 / 1024
